import { render, staticRenderFns } from "./PushTest.vue?vue&type=template&id=cc0827bc&scoped=true"
import script from "./PushTest.vue?vue&type=script&lang=js"
export * from "./PushTest.vue?vue&type=script&lang=js"
import style0 from "./PushTest.vue?vue&type=style&index=0&id=cc0827bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0827bc",
  null
  
)

export default component.exports